import {ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import RiskAreaResponseSchema from '@/schema/RiskAreaResponse.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class RiskAreaResponse extends Resource {

  readonly $name: string = 'RiskAreaResponse'
  readonly $endpoint: string = '/user/area-de-risco'

  get $id() {
    return this.idAreaDeRiscoPk
  }
  set $id(val: ID) {
    this.idAreaDeRiscoPk = val
  }

  get $schema() {
    return RiskAreaResponseSchema(this)
  }

  @ResponseSerialize(Responsavel)
  responsavel = new Responsavel()

  idAreaDeRiscoPk: ID = 0
  cepInicial: string | null = null
  cepFinal: string | null = null
  dataCadastro: string | null = null
  ativo: boolean | null  = null
  notificarNoApp: boolean | null  = null
  notificarNoPainel: boolean | null  = null
}
